export enum Deployments {
  NIGHTSCOUT = "nightscout",
  LIBRELINK = "librelink",
  MCP_NIGHTSCOUT = "mcp-nightscout",
  AUTOTUNE = "autotune",
}

export enum Status {
  INACTIVE = "inactive",
  PENDING = "pending",
  ERROR = "error",
  ACTIVE = "active",
}
